export type Logo = {
  logo: string | undefined;
  name: string | undefined;
};

export const formatLogo = (logo): Logo => {
  if (!logo || !logo?.mimetype || !logo?.content || !logo?.name)
    return {
      logo: undefined,
      name: undefined,
    };
  const prefix = `data:${logo?.mimetype};base64,`;
  return {
    logo: `${prefix}${logo.content}`,
    name: logo?.name || 'logo',
  };
};

export const formatName = (customer) => {
  if (!customer?.first_name) return null;
  return ['For:', customer?.first_name, customer?.last_name]
    .filter((value) => value)
    .join(' ');
};

export const formatDate = (timestamp) => {
  if (!timestamp) return null;

  const date = new Date(timestamp);

  const day = `0${date?.getDate()}`.slice(-2);
  const month = `0${date?.getMonth() + 1}`.slice(-2);
  const year = date?.getFullYear();

  return `Sent: ${day}/${month}/${year}`;
};
